import { render } from "./ExerciseForm.vue?vue&type=template&id=03a7425c&ts=true"
import script from "./ExerciseForm.vue?vue&type=script&lang=ts"
export * from "./ExerciseForm.vue?vue&type=script&lang=ts"

import "./ExerciseForm.vue?vue&type=style&index=0&id=03a7425c&lang=css"

import exportComponent from "/srv/stamincasa/stamincasa-matematica/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__